import TerritoryService from './territory.service';

export default class TerritoryProvider {
  public availableTerritories: string[] = [];

  public init(options) {
    this.availableTerritories = options.availableTerritories;
  }

  public $get() {
    return new TerritoryService(this);
  }
}



// WEBPACK FOOTER //
// src/app/common/services/territory.provider.ts